import RelationshipBg from '../../../assets/images/comprehensive-relationship-diagram.svg';

export default function RelationshipTypesTab({ relationships }) {
  return (
    <div>
      {/* <h3>Relationships</h3> */}
      <img src={RelationshipBg} alt="relationship" />
      {/* {relationships.map((r, i) => (
        <div key={i}>
          {r.from} — {r.relationship} → {r.to}
        </div>
      ))} */}
    </div>
  );
}
